import React from 'react';
import {
  DropdownMenu,
  DropdownMenuCheckboxItem,
  DropdownMenuContent,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

import { Button } from "@/components/ui/button";
import { ChevronDown } from "lucide-react"
import { Table } from '@tanstack/react-table';
import { IArticles, IErrorReturn, IResumessTableColumns } from '@/lib/interfaces';


export const VArticlesTableColumns: IResumessTableColumns = {
    "date": "Created On",
    "title": "Title",
    "snippet": "Content",
    "id": "ID"
}

export interface IArticlesTableColumns {
  [key: string]: string
}

export interface IColumnsSelector {
  table: Table<IArticles | IErrorReturn>,
  VArticlesTableColumns: IArticlesTableColumns
}

function ColumnsSelector({ table, VArticlesTableColumns }: IColumnsSelector) {
  return (
    <DropdownMenu>
        <DropdownMenuTrigger asChild>
            <Button variant="outline" className="ml-auto">
            Columns <ChevronDown />
            </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end">
            {table
            .getAllColumns()
            .filter((column) => column.getCanHide())
            .map((column) => {

                return (
                <DropdownMenuCheckboxItem
                    key={column.id}
                    className="capitalize"
                    checked={column.getIsVisible()}
                    onCheckedChange={(value) =>
                    column.toggleVisibility(!!value)
                    }
                >
                    {VArticlesTableColumns[column.id]}
                </DropdownMenuCheckboxItem>
                )
            })}
        </DropdownMenuContent>
    </DropdownMenu>
  )
}

export default ColumnsSelector